import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Services from '../components/Services'
import About from '../components/About'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import FloatingButtons from '../components/FloatingButtons'

const Home = () => {
  return (
    <div>
      {/* <Navbar/> */}
      <Hero/>
      <Services/>
      <About/>
      <Contact/>
     <FloatingButtons/>
    </div>
  )
}

export default Home
